// extracted by mini-css-extract-plugin
export var component = "RelatedContent-module--component--14ba0";
export var fadePop = "RelatedContent-module--fade-pop--83082";
export var growHeightIn = "RelatedContent-module--grow-height-in--78f1f";
export var title = "RelatedContent-module--title--fd341";
export var underline = "RelatedContent-module--underline--ec8ac";